import React from 'react';
import { Radio as AntRadio, Form } from 'antd';
import type { ComponentConfig, ValueChangeEvent } from '../types';

interface RadioOption {
  label: string;
  value: any;
  description?: string;
}

interface RadioConfig extends ComponentConfig {
  type: 'radio';
}

interface RadioProps {
  config: RadioConfig;
  value?: any;
  onChange: (event: ValueChangeEvent) => void;
  pageId: string;
  error?: string[];
}

export const Radio: React.FC<RadioProps> = ({
  config,
  value,
  onChange,
  pageId,
  error
}) => {
  // Extract radio-specific options from additionalOptions
  const radioOptions = config.additionalOptions || {};
  const options: RadioOption[] = radioOptions.options || [];
  const direction = radioOptions.direction || 'vertical';

  const handleChange = (e: any) => {
    onChange({
      componentId: config.id,
      value: e.target.value,
      pageId
    });
  };

  const validateRules = () => {
    const rules: any[] = [];
    
    if (config.required) {
      rules.push({
        required: true,
        message: `${config.label} is required`
      });
    }
    
    // Add custom validation rules
    config.validation?.forEach(rule => {
      switch (rule.type) {
        case 'custom':
          rules.push({
            validator: rule.value,
            message: rule.message
          });
          break;
        // Add more validation types as needed
      }
    });
    
    return rules;
  };

  const getCurrentValue = () => {
    return value !== undefined ? value : config.defaultValue;
  };

  const formItemProps = {
    label: config.label,
    required: config.required,
    validateStatus: error && error.length > 0 ? 'error' as const : undefined,
    help: error && error.length > 0 ? error[0] : config.description,
    rules: validateRules(),
    labelCol: { span: 24 },
    wrapperCol: { span: 24 }
  };

  return (
    <Form.Item {...formItemProps}>
      <AntRadio.Group
        value={getCurrentValue()}
        onChange={handleChange}
        disabled={config.disabled}
        style={{ width: '100%' }}
      >
        {direction === 'horizontal' ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
            {options.map((option) => (
              <AntRadio key={option.value} value={option.value}>
                <div>
                  <div>{option.label}</div>
                  {option.description && (
                    <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                      {option.description}
                    </div>
                  )}
                </div>
              </AntRadio>
            ))}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {options.map((option) => (
              <AntRadio key={option.value} value={option.value}>
                <div>
                  <div>{option.label}</div>
                  {option.description && (
                    <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                      {option.description}
                    </div>
                  )}
                </div>
              </AntRadio>
            ))}
          </div>
        )}
      </AntRadio.Group>
    </Form.Item>
  );
}; 